import {CourseClassesParams, CourseClass,CourseClassesApi} from '@api';
import {DefaultHttpService} from '../../common/services/HttpService';

class CourseClassServiceBase {
  private api = new CourseClassesApi(new  DefaultHttpService())

  getCourseClasses = (params: CourseClassesParams): Promise<CourseClass[]> => {
    return this.api.getCourseClasses(params);
  }

  getAvailableClasses = (courseId: string): Promise<CourseClass[]> => {
    return this.api.getAvailableClasses(courseId);
  }
}

export const CourseClassService = new CourseClassServiceBase();

/**
 * Convert html properties which was got from HTMLElement with marker HTMLMarkers.ENROL_BUTTON to CourseClass
 */
export const htmlProps2CourseClass = (props: { [key: string]: any }): CourseClass => ({
  course: {
    id: props.courseId,
    code: props.courseCode,
    name: props.courseName,
    description: props.courseDescription
  },
  id: props.id,
  code: props.code,
  hasAvailablePlaces: props.hasAvailablePlaces,
  availableEnrolmentPlaces: props.availableEnrolmentPlaces,
  isFinished: props.isFinished,
  isCancelled: props.isCancelled,
  isAllowByApplication: props.isAllowByApplication,
  isPaymentGatewayEnabled: props.isPaymentGatewayEnabled
});

